import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import RouterComponent from '@navigation/router';
import './App.css';
import {
  checkAuthorized
} from '@actions';

const AppContainer = (props) => {
  useEffect(() => {
    if (!props.has_check_authorized) {
      props.checkAuthorized();
    }
  }, []);

  const renderContent = () => {
    if (props.has_check_authorized) {
      return <RouterComponent />;
    } else {
      return <div />;
    }
  }

  return (
    renderContent()
  )
}

const mapStatesToProps = (state) => {
  const { logged_in, has_check_authorized } = state.auth;
  return { logged_in, has_check_authorized };
};

export default connect(mapStatesToProps, {
  checkAuthorized
})(AppContainer);
